
import LeadPlans from "../components/LeadPlans/LeadPlans";

const LeadPlansPage = () => {
  return (
  <LeadPlans />
  );
};

export default LeadPlansPage; 